<template>
    <div>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">
                                   کال سنتر
                                </h5>
                            </a-col>
                            <a-col :span="24" :md="12"
                                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                ">
                                <a-button class="btn-outline-purple" icon="search" @click="isHidden = !isHidden">
                                    جستجو
                                </a-button>
                                &nbsp;
                               <UploadModal @getData="getData" v-show="$root.hasPermission('/seminars/excel/')" />
                                &nbsp;
                            </a-col>
                        </a-row>
                    </template>
                    <b-card style="margin:20px; !important ; border:none;" v-if="isHidden">
                            <div class="row">
                                <div class="col-md-3 my-1">
                                    <label class="sr-only" for="inline-form-input-name">
                                        شماره همراه</label>
                                    <b-form-input v-model="search.phone" id="inline-form-input-name" class="">
                                    </b-form-input>
                                </div>
                                <div class="col-md-3 my-1">
                                     <UserSearch @ids="getIds" />

                                </div>

                                <div class="col-md-3 my-1">

                                 <label class="sr-only" for="inline-form-input-name"> وضعیت درخواست</label>
                    <select v-model="search.called" class="form-control" name="status">
                        <option value="">انتخاب</option>
                        <option value="0"> تماس گرفته نشده</option>
                        <option value="1"> تماس گرفته شده</option>
                    </select>
                    </div>
                    <div class="col-md-3 my-1">

                                 <label class="sr-only" for="inline-form-input-name"> وضعیت قبول دعوت</label>
                    <select v-model="search.accepted" class="form-control" name="status">
                        <option value="">انتخاب</option>
                        <option value="0"> قبول نشده</option>
                        <option value="1"> قبول شده</option>
                    </select>
                    </div>
                                <div class="col-md-2">
                                    <a-button class="btn-outline-green w-100" icon="search" @click="getData">
                                        جستجو
                                    </a-button>
                                </div>
                            </div>
                    </b-card>

                    <a-row style="justify-content: center; display: flex" v-if="$store.state.loading">
                        <template>
                            <div>
                                <a-spin />
                            </div>
                        </template>
                    </a-row>
                    <div v-else>
                        <section class="w-100 p-4 text-center">
                                                            <div class="table-responsive">

                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">شناسه</th>
                                        <th scope="col">شماره موبایل</th>
                                        <th scope="col"> نام و نام خانوادگی</th>
                                        <th scope="col"> تماس گیرنده </th>
                                        <th scope="col"> توضیحات </th>
                                        <th scope="col"> تماس گرفته شده </th>
                                        <th scope="col"> دعوت پذیرفته شده </th>
                                        <th scope="col">   عملیات </th>


                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in data">
                                        <th scope="row">#{{ row.id }}</th>
                                        <td>{{ row.phone }}</td>
                                        <td>
                                            <b-badge variant="light" class="text-dark">{{ row.name+' '+row.family }} </b-badge>
                                        </td>
                                        <td>
                                            <b-badge variant="light" class="text-dark">{{row.caller ?  $root.full_name(row . caller . firstname , row . caller . lastname) : '' }}</b-badge>
                                        </td>
                                       
                                        <td> {{ row.description }}</td>
                                        <td>
                                         <a-switch v-model="row.called == 1 ? row.called=true:row.called=false"  @change="changeCalled(row.id)"
                                          :disabled="!$root.hasPermission('/seminars/callcenterCall/')" />
                                        </td>
                                        <td>
                                         <a-switch v-model="row.accepted == 1 ? row.accepted=true:row.accepted=false" @change="changeAccepted(row.id)"
                                          :disabled="!$root.hasPermission('/seminars/callcenterInvite/')" />
                                        </td>
                                        <td>
                                            <div class="d-flex">
                                                <Callcenter v-if="row.accepted == 1 && row.called == 1 " :data="row" @getData="getData" />
                                                 &nbsp;
                                            <a-button v-if="row.accepted != 1 || row.called != 1" class="btn-outline-danger" shape="square" icon="delete"
                                              v-show="$root.hasPermission('/seminars/callcenter-delete/')"
                                                @click="deleteRow(`seminars/call/delete/${row.id}`)"></a-button>                                             
   
                                            </div>

                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </section>
                        <a-row class="pagination">
                            <a-pagination :total="total" :item-render="$root.itemRender"
                                @change="getData(currentPage)" v-model="currentPage" />
                        </a-row> 
                    </div>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    import UploadModal from '../../components/Seminars/ModalUploadCallCenter.vue';
    import Callcenter from '../../components/Seminars/ModalCallCenter.vue';
    import UserSearch from "../../components/Blocks/UserSelectMultiple.vue"


    export default {
        components: {
            UploadModal,
            Callcenter,
            UserSearch
        },
        data() {
            return {
                data: [],
                currentPage: 1,
                total: 0,
                isHidden: false,
                search: {
                    phone: "",
                    caller_id: [],
                    called: "",
                    accepted: "",
                },
            };
        },
        methods: {
              getIds(value) {
                this.search.caller_id=value
            },
        async getData() {
            let _this = this;
            let url = `/seminars/guests?page=${this.currentPage}&&phone=${this.search.phone}&&caller_id=${this.search.caller_id}&&called=${this.search.called}&&accepted=${this.search.accepted}`;
            axios
                .get(url)
                .then(function(response) {
                    _this.$store.state.loading = false;
                    _this.data = response.data.data.data;
                    _this.total = response.data.data.total;
                    _this.currentPage = response.data.data.current_page;
                })
                .catch(function(err) {
                    _this.$root.handleAxiosError(err);
                });
        },
        
        async changeCalled(id){
              let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/seminars/guests/called/${id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.getData();
                        _this.$toast.success("کاربر مورد نظر با موفقیت ویرایش شد.");

                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
         },
        
        
        async changeAccepted(id){
              let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/seminars/guests/accepted/${id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.getData();
                        _this.$toast.success("کاربر مورد نظر با موفقیت ویرایش شد.");

                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            handleChange(){
            },
             showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
            },
           deleteRow(url) {
                this.$swal({
                    title: "آیا از حذف اطلاعات اطمینان دارید؟",
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: "بله",
                    denyButtonText: "لغو",
                }).then((result) => {
                    if (result.isConfirmed) {
                        let _this = this;
                        axios
                            .get(url)
                            .then(function(response) {
                                _this.$toast.success("با موفقیت حذف شد.");
                                _this.getData();
                            })
                            .catch(function(err) {
                                _this.$root.handleAxiosError(err);
                            });
                    }
                });
            },
        
        },
        mounted() {
            this.getData();
        },
    };
</script>

<style scope>
    .pagination {
        display: flex;
        justify-content: center;
        margin: 15px;
    }
</style>
